import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';
// Locals
import ar from 'vuetify/src/locale/ar';
import en from 'vuetify/src/locale/en';

import {
  VApp,
  VBtn,
  VMain,
  VForm,
  VIcon,
  VImg,
  VContainer,
  VBreadcrumbs,
  VBreadcrumbsItem,
  VTextField,
  VSpacer,
  VProgressLinear,
} from 'vuetify/lib/components';

Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn,
    VImg,
    VMain,
    VIcon,
    VForm,
    VContainer,
    VBreadcrumbs,
    VBreadcrumbsItem,
    VTextField,
    VSpacer,
    VProgressLinear,
  },
});

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { ar, en },
    current: 'ar',
  },
  theme: {
    themes: {
      light: {
        primary: '#00AD68',
        secondary: '#008d55',
      },
    },
  },
});
